<template>
  <div class="background-03">

    <v-layout row wrap>
      <v-flex xs12 sm2 md2 class="hidden-xs-only ">
        <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="¿Qué son los ingresos variables: " titleLevel="h1">
              <template slot="partOne">¿Qué son los <br></template>
              <!-- <template slot="partTwo"></template> -->
              <template slot="partThree"> ingresos variables?</template>
            </ui-title-one>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'¿Qué son los ingresos variables?'" videoEmbed="ADMINISTRACIONDINERO21QueSonIngresosVariables (52).mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
        <p class="text-box adorn-bottom">
          Se derivan de <strong>actividades ocasionales, trabajos independientes, contratos a término o comisiones</strong> 
              por cumplimiento de metas u objetivos, entre otros.
              <br><br>
              El valor o suma de dinero cambia de acuerdo 
              al tipo o condiciones del trabajo realizado.
        </p>
      </v-flex>
      <v-flex xs12 sm5 md6 mb-5 text-xs-center class="aligner animated fadeIn dura_2">
        <image-app class="animated fadeInLeft" :imaSize="480" imaSrc="contenido/diapositiva_22" imaAlt="Gráfica de ingresos variables"></image-app>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-21.vue?72db21a9